export default class FileHelper {
    static async Base64ToFile(dataUri, filename) {
        const res = await fetch(dataUri);
        const blob = await res.blob();
        return new File([blob], filename, { type: blob.type });
    }
}